import Button, { ButtonType } from '@/components/Button/Button';
import styles from './GetToKnowMore.module.scss';
import Img from '@/components/Img';

interface Image {
  height: number,
  width: number,
  url: string
}

interface IButton {
  id: number,
  title: string,
  type: ButtonType,
  link: string
}

export interface CheckmarkItem {
  id: number;
  text: string;
}

export interface BasicListItem {
  id: number;
  title: string;
  list: { text:string }[]
}

export interface IGetToKnowMore {
  title: string;
  subtitle: string;
  button: IButton;
  cards: {
    id: number,
    title: string;
    subtitle: string;
    description: string;
    button: IButton,
    icon: Image,
    basicLists: BasicListItem[],
    checkmarkList: CheckmarkItem[],
  }[]
}
const Card = ({ card }: { card: IGetToKnowMore['cards'][0] }) => (
  <li className={styles.getToKnowMoreList_card}>
    {card.icon?.url && (
      <Img
        src={card.icon.url}
        height={58}
        width={58}
        alt={card.title}
      />
    )}
    <ul className={styles.getToKnowMoreList_subList}>
      {card.basicLists.map((item) => (
        <li key={item.id}>
          <h5>{card.title}</h5>
          {item.list.length > 0 && (
            <ul>
              {item.list.map((listItem) => (
                <li
                  key={listItem.text}
                  className={styles.getToKnowMoreList_subList_text}
                >
                  {listItem.text}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  </li>
);

const GetToKnowMore: React.FC<{ data: IGetToKnowMore }> = ({ data }) => (
  <section className={styles.getToKnowMore}>
    <div className={styles.getToKnowMoreContent}>
      <div className={styles.getToKnowMoreContent_textContent}>
        <p className={styles.tagline}>{data.subtitle}</p>
        <h2>{data.title}</h2>
        {data.button && (
          <Button
            type={data.button.type}
            href={data.button.link}
            fitContent
            iconName='arrow_forward'
          >
            {data.button.title}
          </Button>
        )}
      </div>

      {data.cards.length > 0 && (
        <ul className={styles.getToKnowMoreList}>
          {data.cards.map((card) => (
            <Card
              key={card.id}
              card={card}
            />
          ))}
        </ul>
      )}
    </div>
  </section>
);

export default GetToKnowMore;
